module.exports = __webpack_public_path__ + "img/front concealed zipper length.0f670479.png";